import { HttpErrorResponse } from '@angular/common/http';
import { createAction, props } from '@ngrx/store';

import { ParameterResult } from '@models/swagger';
import { HomeRegimeParams } from './service';

export enum HomeRegimeActions {
  Failure = '[Catalogs HomeRegime] Failure',
  Request = '[Catalogs HomeRegime] Request',
  Success = '[Catalogs HomeRegime] Success',
}

export const HomeRegimeFailure = createAction(HomeRegimeActions.Failure, props<{ error: HttpErrorResponse }>());

export const HomeRegimeRequest = createAction(HomeRegimeActions.Request, props<{ parameters: HomeRegimeParams }>());

export const HomeRegimeSuccess = createAction(HomeRegimeActions.Success, props<{ data: ParameterResult }>());
